import { type ElementType, memo } from 'react'

import type { CreatorPermission, FeatureFlagName } from '@api'
import { type MeInformation } from '@api'

import type { CreatorFeatures } from '@/modules/accounts/types'
import type { Creator } from '@/modules/creators/types.ts'
import { classNames } from '@/utils/helpers'

export interface NavSingleButtonProps {
  href: string
  hoverRoutes?: string[]
  Icon: ElementType
  children?: NavSingleButtonProps[]
  title: string
  creatorPermission?: CreatorPermission
  creatorFeature?: CreatorFeatures
  accountFeature?: CreatorFeatures
  featureFlagName?: FeatureFlagName
  onlyOwner?: boolean
  onlyAdmin?: boolean
  canSee?: (
    selectedCreator: Creator | null,
    account: MeInformation | null,
  ) => boolean
  isActive?: boolean
  isDisabled?: boolean
  testId?: string
  className?: string
}

const _NavSingleButton = ({
  title,
  Icon,
  isActive,
  isDisabled,
  testId,
  className,
}: NavSingleButtonProps) => {
  return (
    <div
      data-testid={testId ? `navbar-${testId}-item` : undefined}
      className={classNames(
        'text-text-default hover:bg-neutral-contrast dark:hover:bg-secondary-600 flex w-full items-center gap-2 rounded-lg p-2.5',
        {
          'bg-primary-500 text-neutral-default hover:bg-primary-500/90 dark:hover:bg-primary-500/90':
            isActive && !isDisabled,
        },
        {
          'cursor-default text-gray-500': isDisabled,
        },
        className,
      )}
    >
      <Icon />
      <span className="truncate text-sm font-medium">{title}</span>
    </div>
  )
}

export const NavSingleButton = memo(
  _NavSingleButton,
  (oldProps, nextProps) =>
    oldProps.isActive === nextProps.isActive &&
    oldProps.isDisabled === nextProps.isDisabled &&
    oldProps.className === nextProps.className,
)
